export enum SearchFormStyles {
    Primary = "",
    Secondary = "-secondary",
    Tertiary = "-tertiary",
    TertiaryAlt = "-tertiary-alt",
}
